import { useState, useEffect } from 'react';
import { HubConnection, HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';

export interface IUseSignalRConnectionProps {
  url: string;
  connectionCondition: boolean;
  connectionKey: string;
  withAccessFactory?: boolean;
  onMessageReceive?: (...args: any[]) => void;
}

export function useSignalRConnection({ url, connectionCondition, connectionKey, withAccessFactory, onMessageReceive }: IUseSignalRConnectionProps) {
  const [connection, setConnection] = useState<null | HubConnection>(null);

  useEffect(() => {
    if (connectionCondition) {
      const connect = new HubConnectionBuilder()
        .withUrl(url, {
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
          ...(withAccessFactory
            ? {
                accessTokenFactory: () => {
                  const parts = document.cookie.split('session=');
                  const session =
                    parts.length === 2
                      ? parts
                          .pop()!
                          .split(';')
                          .shift()
                      : parts
                          ?.reverse()
                          ?.find(p => p?.includes?.('jwtToken'))
                          ?.split(';')
                          ?.shift();
                  const userResponse = JSON.parse((session || null) as any) || {};
                  return userResponse.jwtToken;
                },
              }
            : {}),
        })
        .withAutomaticReconnect()
        .build();
      setConnection(connect);
    }
  }, [connectionCondition]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection.on(connectionKey, onMessageReceive);
        })
        .catch(error => console.error(error));
    }
  }, [connection]);

  return connection;
}
